import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map, take } from 'rxjs/operators';
import { CustomerService } from '../../resources/auth/customer.service';
import * as _ from 'lodash';

@Injectable()
export class CustomerExistsGuard implements CanActivate {
  constructor(
    private customerService: CustomerService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const customerName: string = route.params['customerName'];
    return this.customerService.customerExists(customerName).pipe(
      take(1),
      map(customerExists => {
        if (customerExists) {
          if (_.endsWith(state.url, customerName)) {
            this.router.navigate([state.url + '/products']);
          }
          return true;
        } else {
          this.router.navigate(['/enrich-page-not-found']);
          return false;
        }
      }),
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routing/customer-exists.guard.ts